const titleSimilarity = (title1, title2) => {
    const words1 = title1.toLowerCase().split(/\s+/)
    const words2 = title2.toLowerCase().split(/\s+/)
    const intersection = words1.filter(w => words2.includes(w))
    const union = new Set([...words1, ...words2])
    return intersection.length / union.size
}

export const getRelatedArticles = async (page) => {
    if (!page) return []
    if (!page.date) return []
    // If manually defined
    if (page?.related?.length > 0) {
        return await queryContent()
            .only(['_path', 'title', 'author', 'thumbnail', 'date', 'tags', 'redirection'])
            .where({ _path: { $in: page.related } })
            .find()
    }

    const allCandidates = await queryContent()
        .only(['_path', 'title', 'author', 'thumbnail', 'date', 'tags', 'keywords', 'redirection'])
        .where({
            _path: {
                $regex: /^\/(news|blog|developers\/tutorials|developers\/showcases)\//,
                $ne: page._path
            }
        })
        .limit(100)
        .find()

    const currentKeywords = page.keywords || []
    const currentTags = page.tags || []
    const currentTitle = page.title || ''

    const scored = allCandidates.map(candidate => {
        let score = 0

        if (candidate.title) {
            score += titleSimilarity(currentTitle, candidate.title) * 2 // mocniejsze wagowanie tytułu
        }

        if (candidate.keywords) {
            const sharedKeywords = candidate.keywords.filter(k => currentKeywords.includes(k))
            score += sharedKeywords.length
        }

        if (candidate.tags) {
            const sharedTags = candidate.tags.filter(t => currentTags.includes(t))
            score += sharedTags.length * 1.5
        }

        return { ...candidate, _score: score }
    })

    // If nothing matches meaningfully, fallback to similar path
    const best = scored
        .sort((a, b) => b._score - a._score)
        .filter(a => a._score > 0)
        .slice(0, 3)

    if (best.length > 0) return best

    // Random fallback if nothing matches
    const similarPath = allCandidates
        .filter(a => a._path?.startsWith(page._path?.split('/').slice(0, 2).join('/')))
        .sort(() => 0.5 - Math.random())
        .slice(0, 3)

    return similarPath
}
